import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

// Import components
import FooterView from './FooterView';
import { fetchGlobals } from '../../../Base/Actions/index';

const FooterController = props => (
  <FooterView {...props} />
);

FooterController.propTypes = {
  copyright: PropTypes.string.isRequired,
  externals: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    blank: PropTypes.bool.isRequired,
  }).isRequired).isRequired,
  social: PropTypes.shape({
    yt: PropTypes.string.isRequired,
    vimeo: PropTypes.string.isRequired,
    fb: PropTypes.string.isRequired,
    twitter: PropTypes.string.isRequired,
    instagram: PropTypes.string.isRequired,
    google: PropTypes.string.isRequired,
  }).isRequired,
  legals: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    blank: PropTypes.bool.isRequired,
  }).isRequired).isRequired,
};

function mapStateToProps(state) {
  return {
    ...state.footerState,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ fetchGlobals }, dispatch);
}


export default connect(mapStateToProps, mapDispatchToProps)(FooterController);



// WEBPACK FOOTER //
// ./frontend/js/Components/Globals/Footer/FooterController.jsx